import { render, staticRenderFns } from "./factory-block.vue?vue&type=template&id=ddf901e2&scoped=true&"
import script from "./factory-block.vue?vue&type=script&lang=js&"
export * from "./factory-block.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./factory-block.vue?vue&type=style&index=1&id=ddf901e2&prod&scoped=true&lang=css&"
import style2 from "./factory-block.vue?vue&type=style&index=2&id=ddf901e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf901e2",
  null
  
)

export default component.exports